<template>
  <div id="jumbo" class="container-fluid" data-v-7e687d7c></div>
  <div id="art" class="container">
    <h1>Colorful Series</h1>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Redmiracle_q.ce56220e.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal13"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Red Miracle (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Green_Sea_q.fcb241a0.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal14"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Green Sea (2024)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Pinksprinkles_q.6bb48398.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal15"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Pink Sprinkles (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Blue_red_quadrat.7747c0aa.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal10"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Blue Red (2024)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Pink_Water_Lilies_quadrat.f6834fe6.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal11"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Pink Water Lilies (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Pink_Water_Lilies_II_quadrat.0f9e739e.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal12"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Pink Water Lilies II (2024)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Beauty_of_Nature_quadrat.7aae9fc9.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal5"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Beauty of Nature (2023)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Spring_Flowers_I_quadrat.60f8619b.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal4"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Spring Flowers I (2023)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Water_lilies_quadrat.afa88612.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal1"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Water Lilies (2023)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Beauty_of_Nature_II_quadrat.14ddb2ac.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal8"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Beauty of Nature II (2023)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Joy_quadrat.e1dfc4cb.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal6"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Joy (2022)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Spring_Flowers_II_quadrat.b09e51dd.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal7"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Spring Flowers II (2023)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/gree_quadratisch.eda66567.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal3"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Bald Eagle (2019)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/red_quadrat.07aac8fa.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal2"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Untitled (2016)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Beauty_of_Nature_III_quadrat.314a7bd8.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal9"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Beauty of Nature III (2024)</p>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal1"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <img
            src="/img/Water_lilies.cbc4b0f1.jpg"
            class="img-fluid"
            alt="..."
            style="max-height: 70vh"
          />
        </div>
        <div class="modal-footer">Water Lilies (2023)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal2"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <img src="/img/red_1.af5ed386.jpg" class="img-fluid" alt="..." style="max-height: 70vh" />
        </div>
        <div class="modal-footer">Untitled (2016)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal3"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <img
            src="/img/IMG_8571.a15d5447.jpg"
            class="img-fluid"
            alt="..."
            style="max-height: 70vh"
          />
        </div>
        <div class="modal-footer">Bald Eagle (2019)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal4"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls4"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Spring_Flowers_I.8796ef70.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Spring_Fliwers_I_V.a81833d8.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls4"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls4"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Spring Flowers I, Acryl on Canvas, 120 x 100 cm (2023)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal5"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls1"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Beauty_of_Nature.ef2ac6f3.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Beauty_of_Nature_V.08dbd174.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Beauty_of_Nature_V2.96b0cfc1.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls1"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls1"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Beauty of Nature, Acryl on Canvas, 100 x 100 cm (2023)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal6"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <img src="/img/Joy.72e5b491.jpg" class="img-fluid" alt="..." style="max-height: 70vh" />
        </div>
        <div class="modal-footer">Joy, Acryl on Canvas, 120 x 100 cm (2022)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal7"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls7"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Spring_Flowers_II.9f1459bd.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Spring_Flowers_II_V.f1d45be0.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls7"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls7"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Spring Flowers II, Acryl on Canvas, 120 x 100 cm (2023)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal8"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Beauty_of_Nature_II.034ed756.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Beauty_of_Nature_II_V.d6e71287.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Beauty of Nature II, Acryl on Canvas, 100 x 100 cm (2023)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal9"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls9"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Beauty_of_Nature_III_V.4bcb95e0.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Beauty_of_Nature_III_V2.232b67bc.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls9"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls9"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Beauty of Nature III, Acryl on Canvas, 100 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal10"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls10"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Blue_Red_V.1cb350c2.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Blue_red_V2.782fde92.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls10"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls10"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Blue Red, Acryl on Canvas, 100 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal11"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls11"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Pink_Water_Lilies_V.41bf9a8c.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pink_Water_Lilies_V2.429d53bc.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls11"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls11"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Pink Water Lilies, Acryl on Canvas, 160 x 120 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal12"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls12"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Pink_Water_Lilies_II_V.40685def.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pink_Water_Lilies_II_V2.9144745e.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls12"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls12"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Pink Water Lilies II, Acryl on Canvas, 80 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal13"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls13"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Redmiracle.8962734c.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Redmiracle_1.eaede999.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Redmiracle_2.c0c2d1e8.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Redmiracle_3.c5e3d135.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Redmiracle_4.2062dd33.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls13"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls13"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Red Miracle, Acryl on Canvas, 120 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal14"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls14"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Green_Sea.78c30240.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Green_Sea_1.9c46bcd3.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Green_Sea_2.58ca85e3.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Green_Sea_3.598a96bf.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls14"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls14"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Green Sea, Acryl on Canvas, 80 x 80 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal15"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls15"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Pinksprinkles.e12eab15.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pinksprinkles_1.c750aa02.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pinksprinkles_2.1fe5171f.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pinksprinkles_3.ce371937.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pinksprinkles_4.19d6bd34.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls15"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls15"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Pink Sprinkles, Acryl on Canvas, 80 x 80 cm (2024)</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Colorful",
};
</script>
